import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { IonIcon } from '@ionic/react';
import { eye, eyeOff } from 'ionicons/icons';
import { Form, Button, Alert, InputGroup } from 'react-bootstrap';
import AuthPage from '../components/layout/AuthPage';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!token) {
      setError('Invalid reset link');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setSubmitting(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL || ''}/api/auth/reset-password`,
        { token, password },
      );
      setSuccess(response.data.message);
      setTimeout(() => navigate('/app', { replace: true }), 2000);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to reset password');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthPage>
      <h1 className="auth-card__title">Choose New Password</h1>

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>New Password</Form.Label>
          <InputGroup>
            <Form.Control
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              minLength={8}
              required
            />
            <InputGroup.Text onClick={() => setShowPassword(!showPassword)} className="peek-toggle">
              <IonIcon icon={showPassword ? eyeOff : eye} />
            </InputGroup.Text>
          </InputGroup>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Confirm Password</Form.Label>
          <Form.Control
            type={showPassword ? 'text' : 'password'}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            minLength={8}
            required
            className={confirmPassword ? (password === confirmPassword ? 'match' : 'mismatch') : ''}
          />
        </Form.Group>
        <Button type="submit" className="button w-100" disabled={submitting}>
          {submitting ? 'Saving...' : 'Reset Password'}
        </Button>
      </Form>

      {success && <Alert variant="success" className="mt-3 mb-0">{success}</Alert>}
      {error && <Alert variant="danger" className="mt-3 mb-0">{error}</Alert>}
    </AuthPage>
  );
};

export default ResetPassword;